import React from "react";

import { Helmet } from "react-helmet";

import Navbar from "../components/navbar";
import ContactForm from "../components/contact-form";
import ContactOptions from "../components/contact-options";
import Footer from "../components/footer";
import "./contact-us.css";

const ContactUs = (props) => {
  return (
    <div className="contact-us-container">
      <Helmet>
        <title>Contact-Us - DPS Tek</title>
        <meta property="og:title" content="Contact-Us - DPS Tek" />
      </Helmet>
      <Navbar></Navbar>
      <ContactForm content1="For inquiries and appointments, please visit our head office during business hours."></ContactForm>
      <ContactOptions email1="info@dpstek.net"></ContactOptions>
      <Footer rootClassName="footer-root-class-name4"></Footer>
    </div>
  );
};

export default ContactUs;
